<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="80vw"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div class="top-bar">
<!--      <div class="chooseInterval">-->
<!--        <el-select-->
<!--          v-model="interval"-->
<!--          placeholder="请设置时间间隔"-->
<!--          size="small"-->
<!--          @change="setInterval">-->
<!--          <el-option label="每天" value="1d"></el-option>-->
<!--          <el-option label="每时" value="1h"></el-option>-->
<!--          <el-option label="每分" value="1m"></el-option>-->
<!--          <el-option label="每10秒" value="10s"></el-option>-->
<!--          <el-option label="每5秒" value="5s"></el-option>-->
<!--        </el-select>-->
<!--      </div>-->

      <datePicker
        :disabledDateNum="7"
        style="float: right"
        :disabledDate="true"
        :dateValue="dateValue"
        align="center"
        @confirmDate="confirmDate"/>
    </div>

    <div style="position: relative;min-height: 500px;margin-top: 20px">
      <div class="nodata" v-if="lineChartDataX && lineChartDataX.length == 0">
        <img
          src="../assets/nodata.svg"
          alt=""
          style="width: 800px; height: 150px"
        />
        <span style="color: #1296db; font-size: larger">无数据</span>
      </div>

      <lineEchart
        ref="mychart"
        v-if="echartType == 'line'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        :show-date="chartShowDate"
        style="width: 100%; height: 450px"
      ></lineEchart>
      <stackedLineEchart
        ref="mychart"
        v-if="echartType == 'stackedLine'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        :legendData="legendData"
        :show-date="chartShowDate"
        style="width: 100%; height: 450px"
      ></stackedLineEchart>
      <barEchart
        ref="mychart"
        v-if="echartType == 'bar'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        :SecondchartDataY="perDataY"
        :show-date="chartShowDate"
        style="width: 100%; height: 450px"
      ></barEchart>
    </div>
  </el-dialog>
</template>

<script>
import lineEchart from "../components/lineEchart.vue";
import datePicker from "../components/datePicker.vue";
import commonUtils from "../utils/common";
import stackedLineEchart from "../components/stackedLineEchart.vue";
import barEchart from "../components/barEchart.vue";
import * as echarts from "echarts";

export default {
  components: { lineEchart, datePicker, stackedLineEchart, barEchart },
  data() {
    return {
      title: "",
      visible: false,
      lineChartDataX: [],
      lineChartDataY: [],
      perDataY: [],
      legendData: [],
      echartType: "",
      chartShowDate: false,
      //datePick参数
      dateValue: [,],
      maxTime: "",
      minTime: "",
      interval: "",

      sensorList:'',
      dataType:''
    };
  },
  methods: {
    show(sensorList,dataType){
      this.visible = true;
      this.sensorList = sensorList;
      this.dataType = dataType
      if (dataType===1){
        this.echartType = "stackedLine";
        this.interval = "1m";
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 1 * 1000),
          new Date(),
        ];
        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(new Date(new Date().getTime() - 3600 * 1000));
      } else if (dataType===2){
        this.echartType = "line";
        this.interval = "1m";
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 1 * 1000),
          new Date(),
        ];
        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(new Date(new Date().getTime() - 3600 * 1000));
      } else if(dataType===3){
        this.echartType = "bar";
        this.interval = "1d";
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 24 * 7 * 1000),
          new Date(),
        ];
        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(new Date(new Date().getTime() - 3600 * 24 * 7* 1000));
      } else if (dataType===4){
        this.echartType = "stackedLine";
        this.interval = "1m";
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 1 * 1000),
          new Date(),
        ];
        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(new Date(new Date().getTime() - 3600 * 1000));
      }


      let diffHours = this.$moment(this.maxTime).diff(this.$moment(this.minTime),'hours');
      if (diffHours<=1){
        this.interval = '1s';
      } else if (diffHours<6){
        this.interval = '5s';
      } else if (diffHours<24*3){
        this.interval = '1m';
      } else if (diffHours<24*7){
        this.interval = '5m';
      } else {
        this.interval = '1h'
      }

      this.getSensorHistory({
        interval: this.interval,
        sensorList: this.sensorList,
        dataType: this.dataType,
        elevatorId: this.$store.state.curElevator.id,
        startTime: this.minTime,
        endTime: this.maxTime,
      });
    },
    //将历史数据转换为图表需要的数据格式
    SensorHistoryToEchartData(dataType, data) {
      //次数
      if (dataType == 5) {
        const chartDataX = data.time;
        const chartDataY = data.counts;
        return { chartDataX, chartDataY };
      }
      //倾角
      if (dataType == 4) {
        const chartDataX = data.time;
        const chartDataY = [
          {
            type: "line",
            name: "x",
            data: data.x,
            showSymbol: false,
            color: "#e6a23c",
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#e6a23c80",
                },
                {
                  offset: 1,
                  color: "#e6a23c",
                },
              ]),
            },
          },
          {
            type: "line",
            name: "y",
            data: data.y,
            showSymbol: false,
            itemStyle: {
              color: "#00d1ed",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00d1ed",
                },
                {
                  offset: 1,
                  color: "#00d1eda3",
                },
              ]),
            },
          },
        ];

        let legendData = [];
        if (chartDataX && chartDataX.length != 0) {
          legendData = ["x", "y"];
        }

        return { chartDataX, chartDataY, legendData };
      }

      //里程
      if (dataType == 3) {
        const chartDataX = data.time;
        const chartDataY = data.distances;
        return { chartDataX, chartDataY };
      }

      //速度
      if (dataType == 2) {
        const chartDataX = data.time;
        const chartDataY = data.speed;
        return { chartDataX, chartDataY };
      }
      //振动传感器
      if (dataType == 1) {
        const chartDataX = data.time;
        const chartDataY = !data.data
          ? null
          : data.data.map((item, index) => {
              return {
                type: "line",
                name: item.position,
                data: item.energy,
                showSymbol: false,
                // itemStyle: {
                //   color:
                //     index == 0 ? "#00d1ed" : index == 1 ? "#e6a23c" : "#ff4646",
                // },
                // areaStyle: {
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //     {
                //       offset: 0,
                //       color:
                //         index == 0
                //           ? "#00d1ed"
                //           : index == 1
                //           ? "#e6a23c"
                //           : "#ff4646",
                //     },
                //     {
                //       offset: 1,
                //       color:
                //         index == 0
                //           ? "#00d1eda3"
                //           : index == 1
                //           ? "#e6a23c80"
                //           : "#ff464680",
                //     },
                //   ]),
                // },
              };
            });
        let legendData = [];
        if (data.time && data.time.length != 0) {
          data.data.forEach((item) => {
            legendData.push(item.position);
          });
        }

        return { chartDataX, chartDataY, legendData };
      }
    },
    getSensorHistory(params) {
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.success) {
          const data = this.SensorHistoryToEchartData(
            params.dataType,
            res.data
          );
          this.lineChartDataX = data.chartDataX;
          this.lineChartDataY = data.chartDataY;

          if (params.dataType == 1 || params.dataType == 4) {
            this.legendData =
              data.chartDataX && data.chartDataX.length != 0
                ? data.legendData
                : [];
          }

          // switch (params.dataType) {
          //   //倾角
          //   case 4:
          //     this.$store.commit("$_setAngleEchartData", data);
          //     break;
          //   //里程
          //   case 3:
          //     this.$store.commit("$_setMileageEchartData", data);
          //     break;
          //   //速度
          //   case 2:
          //     this.$store.commit("$_setSpeedEchartData", data);
          //     break;
          //   //振动
          //   case 1:
          //     this.$store.commit("$_setMotorEchartData", data);
          //     break;
          // }
        }
      });
    },
    // judgeDateTime(min, max) {
    //   if ((new Date(max).getTime() - new Date(min).getTime()) / 1000 > 1800) {
    //     this.$message.warning("时间范围请选择在半小时以内");
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    confirmDate(min, max) {
      // if (this.interval.includes("s")) {
      //   if (this.judgeDateTime(min, max)) {
      //     return;
      //   }
      // }

      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        const num = this.dataType != 3 ? 1 : 24 * 7;

        this.dateValue = [
          new Date(new Date().getTime() - 3600 * num * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * num * 1000)
        );
      }


      let diffMinutes = this.$moment(this.maxTime).diff(this.$moment(this.minTime),'minutes');
      if (diffMinutes<=60){
        this.interval = '1s';
      } else if (diffMinutes<6*60){
        this.interval = '10s';
      } else if (diffMinutes<24*3*60){
        this.interval = '1m';
      } else if (diffMinutes<24*7*60){
        this.interval = '5m';
      } else {
        this.interval = '1h'
      }

      this.chartShowDate = diffMinutes>24*60;


      this.getSensorHistory({
        interval: this.interval,
        sensorList: this.sensorList,
        dataType: this.dataType,
        elevatorId: this.$store.state.curElevator.id,
        startTime: this.minTime,
        endTime: this.maxTime,
      });




      if (this.dataType === 3) {
        const params1 = {
          interval: this.interval,
          sensorList: this.sensorList,
          dataType: 5,
          elevatorId: this.$store.state.curElevator.id,
          startTime: this.minTime,
          endTime: this.maxTime,
        };
        this.$api.sensor.sensorHistory(params1).then((res) => {
          const data = this.SensorHistoryToEchartData(5, res.data);
          this.perDataY = data.chartDataY;
          // this.$store.commit("$_setPerEchartData", data);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>

  /deep/.el-range-editor--small.el-input__inner{
    background: var(--input-bg) !important;
  }

  /deep/.el-range-editor--small .el-range-input{
    background-color: transparent;
    color: white;
  }

  /deep/.el-range-separator{
    color: white;
  }

  /deep/.el-input--small .el-input__inner{
    background-color: transparent;
  }

  /deep/.el-input--small .el-input__inner{
    color: white;
  }


  .top-bar{
    height: 40px;
    line-height: 40px;
  }

.nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  flex-direction: column;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}


//添加动画
.bounce-in-top {
  animation: bounce-in-top 1.1s both;
}

@keyframes bounce-in-top {
  0% {
    transform: translateY(-500px);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    transform: translateY(0);
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    transform: translateY(-65px);
    animation-timing-function: ease-in;
  }
  72% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }
  81% {
    transform: translateY(-28px);
    animation-timing-function: ease-in;
  }
  90% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }
  95% {
    transform: translateY(-8px);
    animation-timing-function: ease-in;
  }
  100% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/echartItemDialog.vue